export const initialBannerState = {
  name: null,
  status: "inactive",
  banners: [
    {
      id: null,
      title: null,
      description: null,
      button_text: null,
      link_url: null,
      resource: null,
      resource_id: null,
      resource_title: null,
      file_id: null,
      duration: null,
      video_id: null,
      video_url: null,
    },
  ],
};

export const state = {
  banners: [],
  emptyBanner: { ...initialBannerState.banners }[0],
  preview: null,
  currentBannerSetEdit: JSON.parse(JSON.stringify(initialBannerState)),
  currentBanner: {
    id: null,
    title: null,
    description: null,
    button_text: null,
    link_url: null,
    resource: null,
    resource_id: null,
    resource_title: null,
    file_id: null,
    status: "inactive",
  }, // backwards compat
  currentBannerSet: JSON.parse(JSON.stringify(initialBannerState)),
  resource_types: [
    { name: "Page", id: "content_page", self: "content" },
    { name: "Form", id: "formmanagement_form", self: "formmanagement" },
    { name: "Policy", id: "policymanagement_policy", self: "policymanagement" },
    { name: "News Article", id: "news_article", self: "news" },
    { name: "Question", id: "collaboration_question", self: "collaboration" },
    {
      name: "Electronic Form",
      id: "eformmanagement_eform",
      self: "eformmanagement",
    },
    { name: "Event", id: "schedule_event", self: "schedule" },
    { name: "File", id: "file", self: "file" },
    { name: "Survey", id: "surveymanagement_survey", self: "surveymanagement" },
  ],
  filters: {
    searchQuery: "",
  },
  sortBy: {
    field: "created_time",
    direction: "desc",
  },
  pagination: {
    total: 10,
    per_page: 10,
    current_page: 1,
    last_page: 1,
    from: 1,
    to: 10,
  },
};
